import { UrgentConcernsScreen } from "app/screens/residents/show/UrgentConcernsScreen";

export default function UrgentConcernsPage() {
  return <UrgentConcernsScreen />;
}
